import fallbackImage from 'icon/custom/fallback-image.svg'

export default {
  install (Vue) {
    Vue.mixin({
      mounted: function () {
        const imageCollection = document.getElementsByTagName('img')
        const imageList = Array.from(imageCollection)

        imageList.forEach(img => {
          img.addEventListener('error', () => img.src = fallbackImage, { passive: true, once: true })
        })
      }
    })
  }
}